module.exports = __webpack_public_path__ + "img/logo.6105a2da.png";